import { connect } from "react-redux";
import { getActiveDocumentType } from "../redux";
import TabNavigationSwitcher from "./tabNavigationSwitcher";
const mapStateToProps = (state) => ({
    documentType: getActiveDocumentType(state)
});
export default connect(mapStateToProps)(TabNavigationSwitcher);
